type ProductStockSnapshot = {
  stock_status?: string | null;
  stock?: number | null;
};

const OUT_OF_STOCK_STATUS = 'OUT_OF_STOCK';

// Revert-friendly toggle: set to false to show out-of-stock products again.
export const ENABLE_HIDE_OUT_OF_STOCK_HIGHLIGHT_PRODUCTS = true;

export const getProductStockStatus = (product: ProductStockSnapshot): string =>
  product.stock_status ??
  ((product.stock ?? 0) > 0 ? 'AVAILABLE' : OUT_OF_STOCK_STATUS);

export const isOutOfStockProduct = (product: ProductStockSnapshot): boolean =>
  getProductStockStatus(product) === OUT_OF_STOCK_STATUS;

export const filterVisibleHighlightProducts = <T extends ProductStockSnapshot>(
  products: T[] = []
): T[] => {
  if (!ENABLE_HIDE_OUT_OF_STOCK_HIGHLIGHT_PRODUCTS) return products;
  return products.filter((product) => !isOutOfStockProduct(product));
};
